module.exports = __webpack_public_path__ + "img/ic_plane_hanging.feb29dbd.svg";